import { render, staticRenderFns } from "./variables.vue?vue&type=template&id=735c6fb3"
import script from "./variables.vue?vue&type=script&lang=js"
export * from "./variables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports